import React from 'react';

const Warmermanual = () => {
  return (

<>


<div className="breadcrumbs overlay">
    <div className="container">
      <div className="bread-inner">
        <div className="row">
          <div className="col-12">
            <h2>Warmer Manual</h2>
          </div>
        </div>
      </div>
    </div>
  </div>


    <div className="youtube-embed align-items-center">
      <iframe 
        width="560" 
        height="315" 
        src="https://www.youtube.com/embed/kgY2OyYE4D4?si=lMxXvKi1G31CsEFb" 
        title="YouTube video player" 
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        referrerPolicy="strict-origin-when-cross-origin" 
        allowFullScreen
      ></iframe>
    </div>
</>
  );
};

export default Warmermanual;
